<template>
    <div id="leagueTask">
        <Headers :headersText='headersText'></Headers>

        <img src="../assets/images/img_80.png" alt="" id="banners">

        <!-- 联盟任务 -->
        <div class="boxPadding">
            <div class="leagueTask">
                <div class="taskItem" v-for="(item,index) in leagueTask" :key="index">
                    <div class="taskItemLeft">
                        <img :src="item.imgs" alt="">
                        <div class="centers">
                            <div class="taskTile">{{item.title}}</div>
                            <div class="others">
                                <span :class="item.charge == '付费' ? 'pay' : ''">{{item.charge}}</span>
                                <span>剩{{item.surplus}}份</span>
                            </div>
                        </div>
                    </div>
                    <div class="taskItemRight"><span>赚</span>{{item.gets}}<span>元</span></div>
                    <div class="lines" v-if="index != leagueTask.length-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'联盟任务',
                // 联盟任务
                leagueTask:[
                    {
                        imgs: require('../assets/images/img_77.png'),
                        title: 'JJ斗地主',
                        charge: '免费',
                        surplus: 1424,
                        gets: '1.5'
                    },
                    {
                        imgs: require('../assets/images/img_77.png'),
                        title: 'JJ斗地主',
                        charge: '免费',
                        surplus: 1424,
                        gets: '1.5'
                    },
                    {
                        imgs: require('../assets/images/img_77.png'),
                        title: 'JJ斗地主',
                        charge: '免费',
                        surplus: 1424,
                        gets: '1.5'
                    }
                ],
            }
        },
        methods: {

        },
    }
</script>

<style lang="less" scoped>
    #leagueTask{
        #banners{
            width: 345px;
            height: 68px;
            margin: 12px 15px 15px;
        }
        .boxPadding{
            padding: 0 15px 15px;
            .leagueTask{
                width:345px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                padding-top: 25px;
                border:1px solid rgba(222,222,222,.5);
                box-sizing: border-box;
                .taskItem{
                    margin: 0 15px 30px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;
                    .taskItemLeft{
                        display: flex;
                        align-items: center;
                        img{
                            width:60px;
                            height:60px;
                        }
                        .imgsDay{
                            width:60px;
                            height:60px;
                            border-radius:11px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            span{
                                font-size:13px;
                                color:rgba(255,255,255,1);
                                line-height:13px;
                                font-weight: bold;
                                &:first-of-type{
                                    margin-bottom: 6px;
                                }
                            }
                        }
                        .centers{
                            height: 60px;
                            margin-left: 15px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;
                            .taskTile{
                                font-size:17px;
                                color:rgba(21,21,21,1);
                                line-height:17px;
                            }
                            .others{
                                span{
                                    display: inline-block;
                                    padding: 5px 13px;
                                    border-radius:12px;
                                    border:1px solid rgba(229,229,229,1);
                                    font-size:12px;
                                    color:rgba(153,153,153,1);
                                    line-height:12px;
                                    &:last-of-type{
                                        margin-left: 10px;
                                    }
                                }
                                .pay{
                                    background:rgba(255,227,227,1);
                                    border:1px solid rgba(243,75,88,1);
                                    color: #E50113;
                                }
                            }
                        }
                    }
                    .taskItemRight{
                        font-size:20px;
                        font-family:'Qds';
                        font-weight: bold;
                        color:rgba(230,9,26,1);
                        line-height:24px;
                        span{
                            font-size: 16px;
                            font-weight: normal;
                        }
                    }
                    .lines{
                        position: absolute;
                        top: 69px;
                        right: 0;
                        width:237px;
                        height:1px;
                        background: #ECECEC;
                    }
                }
            }
        }
    }
</style>